import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Card, CardContent, CardMedia, Typography, Box, Chip } from '@material-ui/core';
import TagCloud from '../common/TagCloud';
import Image from '../common/Image';
import formatDate from '../../utils/formatDate';
import noImageUrl from '../../img/no_image.jpg';

const useStyles = makeStyles((theme) => ({
    root: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: theme.shadows[4],
            cursor: 'pointer'
        }
    },
    media: {
        paddingTop: '75%', // 4:3 aspect ratio
        position: 'relative',
        backgroundColor: theme.palette.grey[100],
        '& img': {
            position: 'absolute',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            objectFit: 'contain'
        }
    },
    content: {
        flexGrow: 1,
        padding: theme.spacing(2),
    },
    title: {
        color: theme.palette.primary.dark,
        marginBottom: theme.spacing(1),
        lineHeight: 1.3
    },
    companyName: {
        marginBottom: theme.spacing(2),
        color: '#c3a604',
        fontSize: '1.6rem',
    },
    tags: {
        display: 'flex',
        gap: theme.spacing(1),
        marginBottom: theme.spacing(2),
        fontSize: '1.2rem',
    },
    areaTag: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
    },
    categoryTag: {
        backgroundColor: theme.palette.warning.main,
        color: theme.palette.warning.contrastText,
    },
    tagCloud: {
        marginTop: theme.spacing(2),
    },
    footer: {
        padding: theme.spacing(2),
        borderTop: `1px solid ${theme.palette.divider}`,
        display: 'flex',
        alignItems: 'center',
    },
    updateTime: {
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing(1),
        fontSize: '1.2rem',
    },
    dateText: {
        fontWeight: 700,
    }
}));

export default function JobCardLarge({ job }) {
    const classes = useStyles();

    let imageUrl = job.mainImage
        ? job.mainImage.image_url
        : (
            job.user.profile.avatar
                ? job.user.profile.avatar.image_url
                : null
        );

    return (
        <Card className={classes.root}>
            <CardMedia className={classes.media}>
                <Image src={imageUrl ? imageUrl : noImageUrl} size={'512'} alt='Company image' />
            </CardMedia>
            <CardContent className={classes.content}>
                <Typography variant="h3" component="h3" className={classes.title}>
                    {job.title}
                </Typography>
                <Typography variant="h5" component="h5" className={classes.companyName}>
                    {job.user.name}
                </Typography>
                <Box className={classes.tags}>
                    <Chip
                        label={job.area ? job.area.name : 'エリア指定無し'}
                        className={classes.areaTag}
                    />
                    <Chip
                        label={job.jobCategory}
                        className={classes.categoryTag}
                    />
                </Box>
                <Box className={classes.tagCloud}>
                    <TagCloud tags={job.tags} />
                </Box>
            </CardContent>
            <Box className={classes.footer}>
                <Box className={classes.updateTime}>
                    <Typography>
                        更新日:
                    </Typography>
                    <time dateTime={job.updated_at}>
                        <Typography className={classes.dateText}>
                            {formatDate(job.updated_at)}
                        </Typography>
                    </time>
                </Box>
            </Box>
        </Card>
    );
}
